
<template>
    
        <c-popup v-if="isShow" :show="isShow" :type="type"><mars-view class="phone-select-popup"><mars-view class="phone-select-title"><mars-text>确认联系电话，方便律师及时与您沟通</mars-text><mars-view class="pop-close" @click.native.stop="onClose"></mars-view></mars-view><mars-view class="phone-select-content"><mars-view class="phone-select-phone-code"><mars-input v-model="phone" class="phone-select-input" placeholder="请输入您的手机号码" placeholder-style="color:#b7b9c1" type="number" :cursor-spacing="50" :maxlength="11" :auto-focus="true" :focus="showPhonePopup" :adjust-position="false" @blur="inputBlur"></mars-input><mars-view v-if="phone" class="icon iconfont phone-select-input-clear" @click.native="popupInputClear"></mars-view></mars-view><mars-view class="line"></mars-view><mars-view class="phone-select-phone-code"><mars-input v-model="code" class="phone-select-input" placeholder="请输入验证码" placeholder-style="color:#b7b9c1" :cursor-spacing="50" type="number" :focus="codeSended" @blur="inputBlur"></mars-input><mars-view class="phone-select-code-text" :class="codeSended ? 'text-transparent' : ''" @click.native="tapSendCodeFn">
                    {{ codeSended ? codeCountdown + '秒后重发' : '发送验证码' }}
                </mars-view></mars-view><mars-view class="line"></mars-view></mars-view><mars-view class="phone-select-bottom"><mars-view v-if="!code || !phone" class="phone-select-button phone-select-button-gray">确认</mars-view><mars-view v-else class="phone-select-button" @click.native.stop="tapCode">确认</mars-view></mars-view></mars-view></c-popup>
    
</template>

<script>
/* globals getApp, Page, swan, getCurrentPages, globalData */
import Popup from "../common/newPopup.vue";
import { reqPathTo } from '../../static/utils/env.js';
import { getData, request } from '../../static/utils/request.js';
export default {
  components: {
    'c-popup': Popup
  },
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    }
  },
  watch: {
    isShow(val) {
      this.init(val);
    }
  },
  data() {
    return {
      showPhonePopup: false,
      codeSended: false,
      // 是否发送验证码
      phone: null,
      // 手机号
      code: null,
      // 验证码
      codeTimer: null,
      // 验证码计时器
      codeCountdown: -1 // 验证码倒计时
    };
  },

  methods: {
    /**
     * 修改手机号码弹框展示控制
     * @param {boolean} isShow  是否展示
     */

    onClose() {
      this.$emit('close');
    },
    /**
     * 初始化数据
     */

    init(isShow) {
      this.showPhonePopup = isShow;
      if (!isShow) {
        this.code = '';
      }
    },
    /**
     * 输入框失去焦点，避免页面留白（兼容ios h5）
     * @return {void}
     */
    inputBlur() {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 200);
    },
    /**
     * 清理手机号内容事件处理
     * @return {void}
     */

    popupInputClear() {
      this.phone = null;
    },
    /**
     * 发送验证码事件处理
     * @return {void}
     */
    tapSendCodeFn() {
      if (this.codeSended) {
        return;
      }
      let phoneValue = this.phone;
      let codeValue = this.code;
      let {
        isEmpty,
        isNotPhone
      } = this.getValidateObj();
      codeValue = [isEmpty.bind(null, phoneValue, '手机号不能为空'), isNotPhone.bind(null, phoneValue, '手机号格式有误')];
      for (let i = 0, validator; validator = codeValue[i++];) {
        let res = validator();
        if (res) {
          this.$api.showToast({
            title: res,
            icon: 'none'
          });
          return;
        }
      }
      if (this.codeTimer) {
        clearInterval(this.codeTimer);
        this.codeTimer = null;
      }
      const sendCode = reqPathTo('sendcode', this.ctx, '', 'law/common');
      // 验证通过 发送验证码
      request({
        url: sendCode,
        data: {
          phone: this.phone,
          type: 'form_consult'
        },
        loginNeeded: false,
        needBduss: true
      });
      this.codeSended = true;
      this.codeCountdown = 30;
      this.codeTimer = setInterval(() => {
        if (this.codeCountdown > 1) {
          this.codeCountdown--;
        } else {
          clearInterval(this.codeTimer);
          this.codeSended = false;
          this.codeTimer = null;
        }
      }, 1000);
    },
    /**
     * 手机号验证事件处理
     * @return {void}
     */
    getValidateObj() {
      // 表单验证策略对象
      return {
        isEmpty(value, error) {
          return !value ? error : '';
        },
        isNotPhone(value, error) {
          return !/^1(3|5|7|8|9)[0-9]{9}$/.test(value) ? error : '';
        }
      };
    },
    /**
     * 验证码校验事件处理
     * @return {void}
     */
    tapCode() {
      if (!/^1(3|5|7|8|9)[0-9]{9}$/.test(this.phone)) {
        this.$api.showToast({
          title: '手机号格式有误',
          icon: 'none'
        });
        return;
      }
      const url = reqPathTo('checkcode', this.ctx, '', 'law/common');
      const code = this.code;
      getData({
        url: url,
        data: {
          phone: this.phone,
          code,
          type: 'form_consult'
        },
        loginNeeded: false,
        needBduss: true
      }).then(data => {
        if (data && data.login) {
          this.$api.showToast({
            title: '修改成功～'
          });
          this.onClose();
          this.$emit('phoneChange', {
            phone: this.phone,
            checkCode: code
          });
        } else {
          this.$api.showToast({
            title: '验证码错误',
            icon: 'none'
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.phone-select-popup {
  height: 70vh;
  padding: 0 4.11vw;
}
.phone-select-popup .phone-select-title {
  position: relative;
  height: 4.59vw;
  line-height: 4.59vw;
  font-family: PingFangSC-Medium;
  font-size: 4.59vw;
  color: #1f1f1f;
  text-align: center;
  padding-top: 4.59vw;
  padding-bottom: 0.97vw;
}
.phone-select-popup .pop-close {
  position: absolute;
  right: 0;
  top: 5.31vw;
  width: 3.14vw;
  height: 3.14vw;
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/clue-collection/clue-collection-popup-close-icon.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.phone-select-popup .line {
  height: 1px;
  background: #f4f4f4;
}
.phone-select-popup .phone-select-input {
  padding: 3.38vw 0;
  font-size: 4.11vw;
  line-height: 1;
  outline: none;
  flex: 1;
  caret-color: #445fbb;
}
.phone-select-popup .phone-select-phone-code {
  display: flex;
  align-items: center;
}
.phone-select-popup .phone-select-phone-code .phone-select-input-clear {
  width: 3.86vw;
  height: 100%;
  color: #ccc;
  font-size: 3.86vw;
  margin-left: 2.42vw;
}
.phone-select-popup .phone-select-phone-code .phone-select-code-text {
  width: fit-content;
  height: 4.11vw;
  flex-grow: 0;
  flex-shrink: 0;
  font-size: 4.11vw;
  color: #336cff;
  text-align: right;
  line-height: 4.11vw;
  font-weight: 400;
  margin-left: 0.72vw;
}
.phone-select-popup .phone-select-phone-code .text-transparent {
  color: #336cff;
}
.phone-select-popup .phone-select-bottom {
  width: 100%;
  margin-top: 4.83vw;
  background: #fff;
}
.phone-select-popup .phone-select-bottom .phone-select-button {
  height: 9.66vw;
  background: #336cff;
  border-radius: 4.59vw;
  line-height: 9.66vw;
  text-align: center;
  font-size: 3.86vw;
  color: #fff;
}
.phone-select-popup .phone-select-bottom .phone-select-button-gray {
  background: #e0e0e0;
}

</style>
